import { Component, Input } from '@angular/core';
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-info-container',
  imports: [
    TranslateModule
  ],
  templateUrl: './info-container.component.html',
  styleUrl: './info-container.component.scss'
})
export class InfoContainerComponent {
  @Input() headerText?: string;
  @Input() subText?: string;
}
